export const commonConfig = {
  darkTheme: true,
  classicHeader: true,
};
